import { keyCode } from './src/keyCode';
import { keyName } from './src/keyName';


export { keyCode, keyName };
